import * as OBC from "@thatopen/components";
export default async function exportFragmentsCurrentModel(components: OBC.Components, currentModel: number) {
    const fragments = components.get(OBC.FragmentsManager);
    console.log('Fragments:', fragments, currentModel);
    if (!fragments.groups.size) {
        return;
    }
    const group = Array.from(fragments.groups.values())[currentModel];
    const data = fragments.export(group);
    return data;
    // handleBlobFileUpload(new File([new Blob([data])], "small.frag"), sasUrl);

}